import { ReactElement } from "react"

import { Control, Controller, FieldValues, Path } from "react-hook-form"

import { PhoneInput, PhoneInputProps } from "../inputs"

export interface PhoneInputFormFieldProps<TFieldValues extends FieldValues>
	extends PhoneInputProps {
	name: Path<TFieldValues>
	control: Control<TFieldValues>
	placeholder?: string
	emptyValueFallback?: string | null
}

export const PhoneInputFormField = <TFieldValues extends FieldValues>({
	name,
	control,
	placeholder,
	emptyValueFallback = null,
	...rest
}: PhoneInputFormFieldProps<TFieldValues>): ReactElement => {
	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { onBlur, value, onChange }, fieldState: { error } }) => {
				return (
					<PhoneInput
						placeholder={placeholder}
						{...rest}
						onBlur={onBlur}
						value={value != null ? String(value).trim() : emptyValueFallback}
						onChange={(newValue) => onChange(newValue || emptyValueFallback)}
						error={error?.message}
					/>
				)
			}}
		/>
	)
}
